import React, { useState, useEffect } from "react";

import RequestHandler from "util/RequestHandler";
import moment from "moment";
import { odata } from "../Filters/Helper";
import TransactionExcelTableFilter from "../Filters/TransactionExcelTableFilter";
import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  Select,
  Tooltip,
  Popconfirm,
  notification,
  message,
} from "antd";
import {
  BarsOutlined,
  SendOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import config from "../../util/ApiforContext";

const TransactionExcel = (props) => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 25,
    current: 1,
    activeTab: "0",
    filter: "",
  });
  const [options, setOptions] = useState({
    pageTitle: "HESAP HAREKETLERİ EXCEL",
  });
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [firmClass, setFirmClass] = useState({
    data: [],
    loading: true,
  });
  const [projects, setProjects] = useState({
    data: [],
    loading: true,
  });

  useEffect(() => {
    getFirmClasses();
    getProjects();
  }, []);

  useEffect(() => {
    getTableData();
  }, [tableDataQueryOptions]);

  const getTableData = (isRefresh) => {
    setSelectedRowKeys([]);

    //isRefresh eşleştirme sonucu dropdownların state i update olması için
    setTableData(
      isRefresh
        ? {
            data: [],
            total: 0,
            loading: true,
          }
        : { ...tableData, loading: true }
    );
    const { skip, take, filter } = tableDataQueryOptions;

    let conditions = ["isDeleted Eq false"];
    let query = "";

    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length !== 0) {
      query = conditions.join(" and ");
    }

    RequestHandler.get(
      `/ErpAccountTransactionExcel?$count=true&$filter=${query}&$skip=${skip}&$top=${take}`
    )
      .then((response) => {
        return response;
      })
      .then((response) => {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      });
  };

  const getFirmClasses = () => {
    RequestHandler.get(`/FirmClass?${odata.orderBy("name")}`).then(
      (response) => {
        setFirmClass({
          data: response.value,
          loading: false,
        });
      }
    );
  };

  const getProjects = () => {
    RequestHandler.get(`/TransactionProjectType?${odata.orderBy("name")}`).then(
      (response) => {
        setProjects({
          data: response.value,
          loading: false,
        });
      }
    );
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
      };
    });
  };

  const onTableSelectChange = (selectedKeys) => {
    setSelectedRowKeys(selectedKeys);
  };

  const onProjectSearch = (value) => {
    if (value.length >= 2) {
      RequestHandler.get(
        `/TransactionProjectType?$select=id,projectCode,name&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains("projectCode", value)})  and Name ne 'Diğer'`
      ).then((res) => {
        if (res.value) {
          setProjects({ data: res.value, loading: false });
        } else {
          setProjects({ data: [], loading: false });
        }
      });
    }
  };

  const onConfirmExport = () => {
    let isSuccess = true;
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );

    if (
      !selectedRowsData.every((row) =>
        firmClass.data.some(
          (firmClassHasErpValue) => firmClassHasErpValue.id === row.firmClassId
        )
      )
    ) {
      notification.error({
        message:
          "Seçili hesap hareketleri içerisinde İşlem Türü seçilmemiş kayıtlar var.",
        duration: 3,
      });
      isSuccess = false;
    }
    if (isSuccess) {
      const hideMessage = message.loading("Excel indiriliyor...", 0);

      RequestHandler.post(
        "/ErpAccountTransactionExcel",
        selectedRowsData,
        false
      ).then((response) => {
        hideMessage();
        if (response) {
          window.open(
            `${
              config.apiUrl
            }/ErpAccountTransactionExcel/DownloadExcel?fileName=${
              response.value
            }&t=${RequestHandler.getToken()}`
          );
        }
        getTableData();
      });
    }
  };

  const getColumns = () => {
    const columnsBeforeDynamicColumns = [
      {
        title: "Banka",
        dataIndex: "bankLogo",
        width: "8%",
        render: (text) => <img src={text}></img>,
      },
      {
        title: "Tutar",
        dataIndex: "amountString",
        render: (data) =>
          data.includes("-") ? (
            <span style={{ whiteSpace: "nowrap", color: "red" }}>{data}</span>
          ) : (
            <span style={{ whiteSpace: "nowrap", color: "green" }}>{data}</span>
          ),
      },
      {
        title: "Tarih",
        dataIndex: "transactionDate",
        render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
      },
      {
        title: "İşlem Türü",
        dataIndex: "firmClassId",
        width: "10%",
        render: (data, row, index) => {
          const firmClassAvailable = firmClass.data.some((e) => e.id === data);

          return (
            <Select
              allowClear
              showSearch
              placeholder="Seçiniz"
              value={firmClassAvailable ? data : undefined}
              style={{ width: "100%" }}
              loading={firmClass.loading}
              onChange={(value, option) => {
                let rows = [...tableData.data];

                let rowToUpdate = {
                  ...row,
                  firmClassId: value,
                  firmClassName: option?.children,
                };
                rows[index] = rowToUpdate;

                setTableData({ ...tableData, data: rows });
              }}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {firmClass.data.map((item) => {
                return (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                );
              })}
            </Select>
          );
        },
      },
      {
        title: "Proje",
        dataIndex: "transactionProjectTypeId",
        width: "20%",
        render: (data, row, index) => {
          return (
            <Select
              allowClear
              showSearch
              placeholder="Seçiniz"
              defaultValue={data ?? undefined}
              style={{ width: "100%" }}
              loading={projects.loading}
              onSearch={onProjectSearch}
              onChange={(value, option) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  transactionProjectTypeId: value,
                  transactionProjectTypeName: option?.children,
                };
                rows[index] = rowToUpdate;

                setTableData({ ...tableData, data: rows });
              }}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {data && (
                <Select.Option
                  key={row.transactionProjectTypeId}
                  value={row.transactionProjectTypeId}
                  transactionProjectTypeName={row.transactionProjectTypeName}
                >
                  {row.transactionProjectTypeCode
                    ? `${row.transactionProjectTypeName} (${row.transactionProjectTypeCode})`
                    : row.transactionProjectTypeName}
                </Select.Option>
              )}

              {projects.data
                .filter((item) => item.id != data)
                .map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name + " (" + item.projectCode + ")"}
                  </Select.Option>
                ))}
            </Select>
          );
        },
      },
    ];

    return columnsBeforeDynamicColumns.concat([
      {
        title: "Açıklama",
        dataIndex: "description",
        render: (text, row, index) => (
          <Tooltip placement="topLeft" title={text}>
            <div style={{ whiteSpace: "break-spaces" }}>
              {text?.trim()?.length > 60
                ? text.substring(0, 125) + "..."
                : text}
            </div>
          </Tooltip>
        ),
      },

      {
        title: "Durum",
        dataIndex: "erpTransferStatusId",
        align: "center",
        render: (i, row) => {
          const icon = {
            0: {
              component: <InfoCircleOutlined />,
            },
            1: {
              component: <InfoCircleOutlined />,
            },
            2: {
              component: <InfoCircleOutlined />,
            },
            3: {
              component: <InfoCircleOutlined />,
            },
            4: {
              color: "green",
              component: <CheckCircleOutlined />,
            },
          };
          return (
            <Tooltip
              title={
                row.erpTransferStatusId !== 4
                  ? "Aktarılmadı"
                  : row.erpTransferStatus
              }
            >
              <a style={{ fontSize: "130%", color: icon[i].color }}>
                {icon[i].component}
              </a>
            </Tooltip>
          );
        },
      },
    ]);
  };

  const isExportAvailable = selectedRowKeys.length > 0;

  const columns = getColumns();

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> {options.pageTitle}
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          <Popconfirm
            title="Aktarmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={selectedRowKeys.length < 1}
            onConfirm={onConfirmExport}
          >
            {isExportAvailable && (
              <Button
                type="primary"
                disabled={selectedRowKeys.length < 1}
                style={{ marginBottom: 0 }}
              >
                <SendOutlined /> Excel'e Aktar
              </Button>
            )}
          </Popconfirm>
        </Col>
      </Row>

      <TransactionExcelTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row id="tableArea">
        <Col span={24}>
          <Table
            rowSelection={{
              selectedRowKeys: selectedRowKeys,
              onChange: onTableSelectChange,
            }}
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["25", "50", "100", "200"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>
    </>
  );
};

export default TransactionExcel;
